import React, { useEffect, useState } from 'react';
import { Routes, Route, useLocation } from "react-router-dom";

//Layouts
import VerticalLayout from "../Layouts/index";
import NonAuthLayout from "../Layouts/NonAuthLayout";

//routes
import { authProtectedRoutes, PublicRoutes } from "./allRoutes";
import { AuthProtected } from './AuthProtected';
import { setauth_status, setprofile_Details, setIsAdmin } from '../slices/globalslice';
import { useSelector, useDispatch } from 'react-redux';
import Cookies from 'universal-cookie';
import { useNavigate } from 'react-router-dom';
import useMaster from '../hooks/useMaster';
import Alt404 from '../pages/Authentication/Errors/Alt404';
import Cover404 from '../pages/Authentication/Errors/Cover404';
import CustomModal from '../Components/Common/CustomModal';
import { fetchMasterData } from '../slices/globalslice';
import ErrorBoundary from '../Components/Common/ErrorBoundary';
import { jwtDecode } from "jwt-decode";
// import { clearAuthToken, getAuthToken, persistAuthToken } from '../utils/authStorage';
const Index = () => {
    const auth_status = useSelector(state => state.globalslice.auth_status);
    //  const profile_Details = useSelector(state => state.globalslice.profile_Details);


    // const dispatch = useDispatch()
    // const { getMenuAccess } = useMaster()

    // const { isLoading, data } = getMenuAccess()

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { getMenuAccess } = useMaster();

    const { isLoading, data } = getMenuAccess();
    const cookies = new Cookies();

    const [routes, setRoutes] = useState([]);

    useEffect(() => {
        if (auth_status) {
            dispatch(fetchMasterData());
        }
    }, [auth_status]);
//  useEffect(() => {
//         const params = new URLSearchParams(window.location.search);
//         const jwtFromUrl = params.get('jwt') || params.get('jwt_token');

//         if (jwtFromUrl) {
//             persistAuthToken(jwtFromUrl);

//             try {
//                 const decoded = jwtDecode(jwtFromUrl);
//                 dispatch(setauth_status(true));
//                 dispatch(setprofile_Details(decoded));

//                 const isUserAdmin = decoded?.group?.some(group => group.slug === 'admin');
//                 dispatch(setIsAdmin(isUserAdmin));

//                 // Optional: remove token from URL (for cleaner appearance)
//                 const newUrl = window.location.pathname;
//                 window.history.replaceState({}, '', newUrl);
//             } catch (err) {
//                 console.error('Invalid JWT token in URL:', err);
//                 clearAuthToken();
//                 dispatch(setauth_status(false));
//             }
//         }
//     }, []);
    const extractValidPaths = (data) => {
        return data.flatMap(item => {
            const paths = [];

            // Add top-level url_path if it's not "/#"
            if (item.url_path && item.url_path !== "/#") {
                paths.push(item.url_path);
            }

            // Add submenu url_paths if they exist and are not "/#"
            if (item.submenus?.length) {
                const subPaths = item.submenus
                    .filter(sub => sub.url_path && sub.url_path !== "/#")
                    .map(sub => sub.url_path);

                paths.push(...subPaths);
            }

            return paths;
        });
    };

    const doesPathMatch = (routes, pathname) => {
        return routes.some(route => {
            return pathname === route || pathname.startsWith(`${route}/`);
        });
    };

    const location = useLocation();

    /*
    useEffect(() => {
        if (data?.data && auth_status) {
            const routes = extractValidPaths(data?.data ?? []);
            setRoutes(routes)
        } else {
            setRoutes([])
        }
// const token = getAuthToken();
        const token = cookies.get('token');

        if (token != undefined) {
            dispatch(setauth_status(true))
            const decoded = jwtDecode(token);
            dispatch(setprofile_Details(decoded))
            const isUserAdmin = decoded?.group?.some(group => group.slug === 'admin');
            dispatch(setIsAdmin(isUserAdmin))
        } else {
            dispatch(setauth_status(false))
            navigate('/')
        }
    }, [data, auth_status])
    */

    /*
    useEffect(() => {
        const token = cookies.get('token');

        if (token) {
            dispatch(setauth_status(true));

            const decoded = jwtDecode(token);
            dispatch(setprofile_Details(decoded));

            const isUserAdmin = decoded?.group?.some(group => group.slug === 'admin');
            dispatch(setIsAdmin(isUserAdmin));
        } else {
            dispatch(setauth_status(false));

            // DO NOT redirect if on public routes
            const publicPaths = [
                '/',
                '/register',
                '/forgot-password',
                '/verify-otp',
                '/reset-password',
                '/resend-otp',
                '/otp-success'
            ];

            if (!publicPaths.includes(location.pathname)) {
                // navigate('/');
            }
        }

        if (data?.data && token) {
            const routes = extractValidPaths(data?.data ?? []);
            setRoutes(routes);
        } else {
            setRoutes([]);
        }

    }, [data, location.pathname]);
    */

    useEffect(() => {
        const token = cookies.get('token');

        if (token) {
            if (!auth_status) {
                dispatch(setauth_status(true));
            }

            try {
                // dispatch(setauth_status(true))
                const decoded = jwtDecode(token);
                dispatch(setprofile_Details(decoded));

                const isUserAdmin = decoded?.group?.some(group => group.slug === 'admin');
                dispatch(setIsAdmin(isUserAdmin));
            } catch (error) {
                console.error("Invalid token");
                // clearAuthToken();
                // dispatch(setauth_status(false))
                // dispatch(setprofile_Details({}))
                // dispatch(setIsAdmin(false))
            }

        } else {
            // OLD CODE (commented)
            // dispatch(setauth_status(false));
// dispatch(setauth_status(false))
//             dispatch(setprofile_Details({}))
//             dispatch(setIsAdmin(false))
            // NEW SAFE CHECK
            if (auth_status !== false) {
                dispatch(setauth_status(false));
            }
        }

        // SET ROUTES ONLY WHEN TOKEN EXISTS
        if (data?.data && token) {
            const routes = extractValidPaths(data?.data ?? []);
            setRoutes(routes);
        }

    }, [data]);

//  const doesPathMatch = (routes, pathname) => {
//         return routes.some(route => {
//             return pathname === route || pathname.startsWith(`${route}/`);
//         });
//     };
//     const location = useLocation();
    if (auth_status === undefined) return null;

    return (
        <React.Fragment>
            {/*
            {
                !auth_status ?
                    <Routes>
                    <Route>
                        {PublicRoutes.map((route, idx) => (
                            <Route
                                key={idx}
                                path={route.path}
                                element={
                                    <NonAuthLayout>
                                        {route.component}
                                    </NonAuthLayout>}
                                    key={idx}
                                    exact={true}
                                }
                            />
                        ))}
                         </Route>
                    </Routes>
                    :
                    isLoading ?
                        <div id="preloader">
                            <div id="status">
                                <div className="spinner-border text-primary avatar-sm" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        </div>
                        :
                        <Routes>
                         <Route>
                            {routes.length > 0 && authProtectedRoutes.map((route, idx) => (
                                <Route
                                    key={idx}
                                    path={route.path}
                                    element={
                                        <AuthProtected>
                                            <VerticalLayout key={location.pathname + route.path}>
                                                <ErrorBoundary fallback={<div className="page-content">Oops! Something went wrong in loading the page.</div>}>
                                                    {(() => {
                                                        const path = window.location.pathname;
                                                        const isHome = path === "/";
                                                        const isValidRoute = doesPathMatch(routes, path);
                                                        const isAuthRoute = authProtectedRoutes
                                                            .slice(0, -2)
                                                            .flatMap(({ path }) => path)
                                                            .includes(path);

                                                        const content = isHome
                                                            ? route.component
                                                            : isValidRoute
                                                                ? route.component
                                                                : isAuthRoute
                                                                    ? <Alt404 />
                                                                    : <Cover404 />;

                                                        if (profile_Details?.source === "web") {
                                                            return (
                                                                <VerticalLayout key={`${location.pathname}${route.path}`}>
                                                                    {content}
                                                                </VerticalLayout>
                                                            );
                                                        }

                                                        return content;
                                                    })()}
                                                </ErrorBoundary>
                                            </VerticalLayout>
                                        </AuthProtected>
                                    }
                                         key={idx}
                                        exact={true}
                                />
                            ))}
                                </Route>
                        </Routes>
            }
            */}

            <Routes>
                {PublicRoutes.map((route, idx) => (
                    <Route
                        key={`public-${idx}`}
                        path={route.path}
                        element={
                            <NonAuthLayout>
                                {route.component}
                            </NonAuthLayout>
                        }
                    />
                ))}

                {authProtectedRoutes.map((route, idx) => (
                    <Route
                        key={`protected-${idx}`}
                        path={route.path}
                        element={
                            <AuthProtected>
                                <VerticalLayout key={location.pathname + route.path}>
                                    {route.component}
                                </VerticalLayout>
                            </AuthProtected>
                        }
                    />
                ))}
            </Routes>
            <CustomModal />
        </React.Fragment>
    );
};

export default Index;
